// 简体转繁体 + 台湾常用词
const CHAR_MAP: Record<string, string> = {
  总: '總', 产: '產', 页: '頁', 电: '電', 网: '網', 这: '這', 说: '說',
  过: '過', 还: '還', 个: '個', 们: '們', 来: '來', 对: '對', 时: '時',
  会: '會', 经: '經', 现: '現', 开: '開', 长: '長', 门: '門', 问: '問',
  间: '間', 样: '樣', 动: '動', 进: '進', 实: '實', 学: '學', 机: '機',
  种: '種', 见: '見', 觉: '覺', 书: '書', 买: '買', 卖: '賣', 钱: '錢',
  览: '覽', 联: '聯', 获: '獲', 设: '設', 计: '計', 认: '認', 证: '證',
  请: '請', 输: '輸', 码: '碼', 发: '發', 创: '創', 账: '帳', 号: '號',
  邮: '郵', 绑: '綁', 删: '刪', 载: '載', 图: '圖', 录: '錄', 订: '訂',
  单: '單', 价: '價', 资: '資', 显: '顯', 调: '調', 试: '試', 错: '錯',
  误: '誤', 备: '備', 关: '關', 闭: '閉', 复: '復', 杂: '雜', 简: '簡',
  体: '體', 汉: '漢', 语: '語', 译: '譯', 转: '轉', 换: '換', 选: '選',
  择: '擇', 项: '項', 确: '確', 执: '執', 处: '處', 状: '狀', 态: '態',
  历: '歷', 记: '記', 详: '詳', 细: '細', 汇: '匯', 报: '報', 导: '導',
  户: '戶', 国: '國', 际: '際', 华: '華', 东: '東', 广: '廣', 场: '場',
  厂: '廠', 层: '層', 级: '級', 类: '類', 别: '別', 标: '標', 准: '準',
  规: '規', 则: '則', 权: '權', 护: '護', 监: '監', 检: '檢', 测: '測',
  验: '驗', 质: '質', 数: '數', 据: '據', 库: '庫', 储: '儲', 读: '讀',
  写: '寫', 编: '編', 减: '減', 扩: '擴', 缩: '縮', 压: '壓', 启: '啟',
  续: '續', 断: '斷', 连: '連', 离: '離', 线: '線', 无: '無', 环: '環',
  变: '變', 旧: '舊', 帮: '幫', 响: '響', 应: '應', 该: '該', 当: '當',
  后: '後', 内: '內', 里: '裡', 边: '邊', 侧: '側', 顶: '頂', 头: '頭',
  宽: '寬', 浅: '淺', 强: '強', 远: '遠', 满: '滿', 闲: '閒', 热: '熱',
  温: '溫', 凉: '涼', 干: '乾', 湿: '濕', 净: '淨', 脏: '髒', 洁: '潔',
  红: '紅', 绿: '綠', 蓝: '藍', 黄: '黃', 银: '銀', 铜: '銅', 铁: '鐵',
  钢: '鋼', 风: '風', 云: '雲', 雾: '霧', 闪: '閃', 阳: '陽', 阴: '陰',
  岁: '歲', 钟: '鐘', 纳: '納', 飞: '飛', 爱: '愛', 乐: '樂', 惊: '驚',
  虑: '慮', 忆: '憶', 识: '識', 涂: '塗', 乱: '亂', 齐: '齊', 优: '優',
  势: '勢', 胜: '勝', 负: '負', 败: '敗', 赢: '贏', 竞: '競', 争: '爭',
  斗: '鬥', 战: '戰', 协: '協', 议: '議', 谈: '談', 决: '決', 划: '劃',
  组: '組', 织: '織', 构: '構', 结: '結', 继: '繼', 暂: '暫', 锁: '鎖',
  签: '簽', 注: '註', 册: '冊', 访: '訪', 浏: '瀏', 寻: '尋', 传: '傳',
  异: '異', 题: '題', 维: '維', 补: '補', 审: '審', 驳: '駁', 绝: '絕',
  销: '銷', 货: '貨', 评: '評', 诉: '訴', 馈: '饋', 务: '務', 络: '絡',
  沟: '溝', 询: '詢', 论: '論', 点: '點', 赞: '讚', 贴: '貼', 为: '為',
  预: '預', 栏: '欄', 条: '條', 滚: '滾', 块: '塊', 钮: '鈕', 链: '鏈',
  视: '視', 频: '頻', 档: '檔', 夹: '夾', 装: '裝', 运: '運', 冲: '衝',
  并: '併', 岛: '島', 湾: '灣', 与: '與', 众: '眾', 余: '餘', 侦: '偵',
  侨: '僑', 俩: '倆', 仓: '倉', 龟: '龜', 亩: '畝', 亲: '親', 亿: '億',
  仅: '僅', 从: '從', 仑: '侖', 仪: '儀', 伞: '傘', 伟: '偉', 伤: '傷',
  伦: '倫', 伪: '偽', 伫: '佇', 侠: '俠', 侣: '侶', 侥: '僥', 侬: '儂',
  俨: '儼', 没: '沒', 么: '麼', 周: '週', 软: '軟', 盘: '碟', 讯: '訊',
  系: '繫', 于: '於', 触: '觸', 跃: '躍', 币: '幣', 击: '擊', 杠: '槓', 杆: '桿',
  龙: '龍', 业: '業', 团: '團', 让: '讓', 兰: '蘭', 兴: '興', 养: '養', 兽: '獸',
  举: '舉', 义: '義', 乌: '烏', 乐: '樂', 乔: '喬', 习: '習', 乡: '鄉', 亚: '亞',
  亏: '虧', 亿: '億', 仅: '僅', 仓: '倉', 仪: '儀', 们: '們', 众: '眾', 优: '優',
  会: '會', 伞: '傘', 伟: '偉', 传: '傳', 伤: '傷', 伦: '倫', 伪: '偽', 伫: '佇',
  侠: '俠', 侣: '侶', 侥: '僥', 侦: '偵', 侧: '側', 侨: '僑', 侬: '儂', 俨: '儼',
  俩: '倆', 仓: '倉', 龟: '龜', 亩: '畝', 亲: '親', 从: '從', 仑: '侖', 汉: '漢',
  汤: '湯', 沟: '溝', 没: '沒', 沪: '滬', 泪: '淚', 洁: '潔', 测: '測', 浏: '瀏',
  浑: '渾', 浓: '濃', 涛: '濤', 涝: '澇', 滨: '濱', 滩: '灘', 灭: '滅', 灯: '燈',
  灵: '靈', 灾: '災', 灿: '燦', 炉: '爐', 烂: '爛', 爷: '爺', 墙: '牆', 产: '產',
  画: '畫', 畅: '暢', 异: '異', 疯: '瘋', 疗: '療', 盖: '蓋', 盗: '盜', 盘: '盤',
  睁: '睜', 矿: '礦', 码: '碼', 砖: '磚', 礼: '禮', 祸: '禍', 离: '離', 种: '種',
  积: '積', 称: '稱', 穷: '窮', 竞: '競', 笔: '筆', 节: '節', 药: '藥', 虽: '雖',
  虾: '蝦', 补: '補', 装: '裝', 览: '覽', 觉: '覺', 计: '計', 认: '認', 让: '讓',
  许: '許', 论: '論', 诉: '訴', 词: '詞', 诗: '詩', 话: '話', 详: '詳', 语: '語',
  误: '誤', 说: '說', 请: '請', 诸: '諸', 读: '讀', 课: '課', 谁: '誰', 调: '調',
  谈: '談', 谢: '謝', 谨: '謹', 谱: '譜', 贝: '貝', 贡: '貢', 财: '財', 责: '責',
  贤: '賢', 货: '貨', 质: '質', 贪: '貪', 购: '購', 贱: '賤', 贴: '貼', 贷: '貸',
  贸: '貿', 费: '費', 贺: '賀', 赃: '贓', 资: '資', 赌: '賭', 赎: '贖', 赚: '賺',
  赛: '賽', 赞: '讚', 赠: '贈', 赢: '贏', 赵: '趙', 趋: '趨', 跃: '躍', 践: '踐',
  车: '車', 轨: '軌', 转: '轉', 轮: '輪', 软: '軟', 轰: '轟', 轴: '軸', 轻: '輕',
  载: '載', 较: '較', 辅: '輔', 辆: '輛', 辈: '輩', 辉: '輝', 辑: '輯', 输: '輸',
  辩: '辯', 边: '邊', 达: '達', 迁: '遷', 过: '過', 迈: '邁', 运: '運', 还: '還',
  这: '這', 进: '進', 远: '遠', 违: '違', 连: '連', 迟: '遲', 选: '選', 递: '遞',
  逻: '邏', 遗: '遺', 邮: '郵', 邻: '鄰', 郑: '鄭', 释: '釋', 里: '裡', 针: '針',
  钓: '釣', 钟: '鐘', 钢: '鋼', 钱: '錢', 钻: '鑽', 铁: '鐵', 铃: '鈴', 铅: '鉛',
  铜: '銅', 铝: '鋁', 银: '銀', 铺: '鋪', 链: '鏈', 销: '銷', 锁: '鎖', 锅: '鍋',
  锈: '鏽', 锋: '鋒', 锐: '銳', 错: '錯', 锡: '錫', 锦: '錦', 键: '鍵', 镇: '鎮',
  镜: '鏡', 长: '長', 门: '門', 闪: '閃', 闭: '閉', 问: '問', 间: '間', 闻: '聞',
  阁: '閣', 阅: '閱', 阐: '闡', 队: '隊', 阳: '陽', 阴: '陰', 阵: '陣', 阶: '階',
  际: '際', 陆: '陸', 陈: '陳', 险: '險', 隐: '隱', 难: '難', 雾: '霧', 静: '靜',
  顶: '頂', 项: '項', 顺: '順', 须: '須', 预: '預', 领: '領', 频: '頻', 颗: '顆',
  题: '題', 颜: '顏', 额: '額', 风: '風', 飞: '飛', 饭: '飯', 饮: '飲', 饰: '飾',
  饱: '飽', 饼: '餅', 馆: '館', 马: '馬', 驱: '驅', 验: '驗', 骑: '騎', 骗: '騙',
  骤: '驟', 骨: '骨', 体: '體', 高: '高', 鬼: '鬼', 鱼: '魚', 鸟: '鳥', 鸡: '雞',
  鸣: '鳴', 鸭: '鴨', 鸽: '鴿', 鹅: '鵝', 麦: '麥', 黄: '黃', 齐: '齊', 齿: '齒',
  龄: '齡', 龙: '龍', 龟: '龜',
}

const PHRASE_MAP: [string, string][] = [
  ['刷新', '重新整理'],
  ['充值', '儲值'],
  ['联系', '聯絡'],
  ['联繫', '聯絡'],
  ['获取', '取得'],
  ['软件', '軟體'],
  ['信息', '資訊'],
  ['支持', '支援'],
  ['客户', '客戶'],
  ['邮件', '電子郵件'],
  ['邮箱', '電子郵件'],
  ['短信', '簡訊'],
  ['视频', '影片'],
  ['默认', '預設'],
  ['服务器', '伺服器'],
  ['网络', '網路'],
  ['程序', '程式'],
  ['内存', '記憶體'],
  ['硬盘', '硬碟'],
  ['登录', '登入'],
  ['注册', '註冊'],
  ['账户', '帳戶'],
  ['账号', '帳號'],
  ['验证码', '驗證碼'],
  ['身份证', '身分證'],
  ['下载', '下載'],
  ['上传', '上傳'],
  ['链接', '連結'],
  ['加载', '載入'],
  ['加载中', '載入中'],
  ['暂无数据', '暫無資料'],
  ['处理中', '處理中'],
  ['失败', '失敗'],
  ['网络错误', '網路錯誤'],
  ['稍后重试', '稍後重試'],
  ['倒计时', '倒數計時'],
  ['亏损', '虧損'],
  ['盈利', '獲利'],
  ['用户', '用戶'],
  ['管理员', '管理員'],
  ['开发', '開發'],
  ['填写', '填寫'],
  ['还没有', '還沒有'],
  ['没有', '沒有'],
  ['当前', '目前'],
  ['当前密码', '目前密碼'],
  ['身份认证', '身分認證'],
  ['真实姓名', '真實姓名'],
  ['证件号码', '證件號碼'],
  ['身份证号码', '身分證號碼'],
  ['身份证正面', '身分證正面'],
  ['身份证反面', '身分證反面'],
  ['点击上传', '點擊上傳'],
  ['为了保障', '為了保障'],
  ['账户安全', '帳戶安全'],
  ['身份信息', '身分資訊'],
  ['刷新状态', '重新整理狀態'],
  ['退出登录', '登出'],
  ['登录成功', '登入成功'],
  ['登录失败', '登入失敗'],
  ['立即登录', '立即登入'],
  ['立即注册', '立即註冊'],
  ['注册成功', '註冊成功'],
  ['注册失败', '註冊失敗'],
  ['创建新账户', '建立新帳戶'],
  ['邮箱注册', '電子郵件註冊'],
  ['账号注册', '帳號註冊'],
  ['发送验证码', '發送驗證碼'],
  ['已有账号', '已有帳號'],
  ['登录您的账户', '登入您的帳戶'],
  ['重新登录', '重新登入'],
  ['在线', '線上'],
  ['离线', '離線'],
  ['连接中', '連線中'],
  ['发送', '傳送'],
  ['客服人员', '客服人員'],
  ['加密货币', '加密貨幣'],
  ['市场概览', '市場概覽'],
  ['高流动性', '高流動性'],
  ['总资产', '總資產'],
  ['收益率', '報酬率'],
  ['简体中文', '簡體中文'],
  ['繁体中文', '繁體中文'],
  ['日语', '日語'],
  ['密码错误', '密碼錯誤'],
  ['用户不存在', '用戶不存在'],
  ['会话', '工作階段'],
  ['超时', '逾時'],
  ['无操作', '無操作'],
  ['打开', '開啟'],
  ['创建提醒', '建立提醒'],
  ['价格提醒', '價格提醒'],
  ['总提醒数', '總提醒數'],
  ['活跃提醒', '活躍提醒'],
  ['已触发', '已觸發'],
  ['条记录', '筆記錄'],
  ['图表数据', '圖表資料'],
  ['获取图表数据失败', '取得圖表資料失敗'],
  ['输入您的问题', '輸入您的問題'],
  ['杠杆交易', '現貨交易'],
  ['秒合约', '秒合約'],
  ['提现', '提現'],
  ['修改密码', '修改密碼'],
  ['版本信息', '版本資訊'],
  ['查看资产', '查看資產'],
  ['交易记录', '交易紀錄'],
  ['活动记录', '活動紀錄'],
  ['委托中', '委託中'],
  ['当前委托', '目前委託'],
  ['已撤单', '已撤單'],
  ['撤单记录', '撤單紀錄'],
  ['持仓中', '持倉中'],
  ['平仓记录', '平倉紀錄'],
  ['已平仓', '已平倉'],
  ['已爆仓', '已爆倉'],
  ['开仓价', '開倉價'],
  ['平仓价', '平倉價'],
  ['平仓价格', '平倉價格'],
  ['搜索资产', '搜尋資產'],
  ['钱包管理', '錢包管理'],
  ['账户记录', '帳戶紀錄'],
  ['关于我们', '關於我們'],
  ['最近活动', '最近活動'],
  ['安全等级', '安全等級'],
  ['已认证', '已認證'],
  ['请输入', '請輸入'],
  ['请确认', '請確認'],
  ['请填写', '請填寫'],
  ['请上传', '請上傳'],
  ['请等待', '請等待'],
  ['审核中', '審核中'],
  ['拒绝原因', '拒絕原因'],
  ['提交时间', '提交時間'],
  ['提交失败', '提交失敗'],
  ['实际到账', '實際到帳'],
  ['手续费', '手續費'],
  ['价格走势', '價格走勢'],
  ['订单记录', '訂單紀錄'],
  ['合约时长', '合約時長'],
  ['投资金额', '投資金額'],
  ['当前价格', '目前價格'],
  ['预计收益', '預計收益'],
  ['可用余额', '可用餘額'],
  ['确认看涨', '確認看漲'],
  ['确认看跌', '確認看跌'],
  ['订单已提交', '訂單已提交'],
  ['余额不足', '餘額不足'],
  ['进行中', '進行中'],
  ['已结算', '已結算'],
  ['确定要删除', '確定要刪除'],
  ['选择资产', '選擇資產'],
  ['触发条件', '觸發條件'],
  ['价格高于', '價格高於'],
  ['价格低于', '價格低於'],
  ['目标价格', '目標價格'],
  ['邮件通知', '郵件通知'],
  ['推送通知', '推播通知'],
  ['启用状态', '啟用狀態'],
  ['邮箱地址', '電子郵件地址'],
  ['再次输入', '再次輸入'],
  ['所有必填项', '所有必填項'],
  ['验证码错误', '驗證碼錯誤'],
  ['邮箱或密码错误', '電子郵件或密碼錯誤'],
  ['请输入账号和密码', '請輸入帳號和密碼'],
  ['开发模式', '開發模式'],
  ['如果收不到邮件', '如果收不到郵件'],
  ['后端控制台', '後端控制台'],
  ['提现已通过审核', '提現已通過審核'],
  ['提现被驳回', '提現被駁回'],
  ['杠杆交易平仓', '現貨交易平倉'],
  ['杠杆交易爆仓', '現貨交易爆倉'],
  ['损失保证金', '損失保證金'],
  ['管理员上分', '管理員上分'],
  ['什么', '什麼'],
  ['怎么', '怎麼'],
  ['为什么', '為什麼'],
]

export function toTraditional(text: string): string {
  if (!text) return text
  let result = text
  for (const [from, to] of PHRASE_MAP) {
    result = result.split(from).join(to)
  }
  return result
    .split('')
    .map((char) => CHAR_MAP[char] ?? char)
    .join('')
}

export function deepToTraditional<T>(obj: T): T {
  if (typeof obj === 'string') {
    return toTraditional(obj) as T
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => deepToTraditional(item)) as T
  }
  if (obj && typeof obj === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(obj)) {
      result[key] = deepToTraditional(value)
    }
    return result as T
  }
  return obj
}
